import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Section } from "./section";
import { Detail } from "./detail";
import { AmountOnDate } from "@/api/types/main/schemas";
import { format } from "date-fns";
import { ru } from "date-fns/locale";

interface StockDetailProps {
  detail: {
    quantityLeftOnMarketplace: number;
    enoughForDays: number;
    quantityLeftOnMoscowWarehouse: number;
    reservedOnMarketplace: number;
    wayToMarketplace: number;
    nearestDeliveries: AmountOnDate[];
    nearestDeliveriesToMoscow: AmountOnDate[];
  };
}

export const StockDetail = ({ detail }: StockDetailProps) => {
  return (
    <Card className="p-4 h-full">
      <CardHeader>
        <CardTitle>Информация по остаткам</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-y-3">
        <Section title="Остатки">
          <Detail label="Остаток на МП" value={detail.quantityLeftOnMarketplace} />
          <Detail label="Хватит на" value={Math.floor(detail.enoughForDays)} />
          <Detail label="Склад Москва" value={detail.quantityLeftOnMoscowWarehouse} />
          <Detail label="В пути на МП" value={detail.wayToMarketplace} />
          <Detail label="Резерв на МП" value={detail.reservedOnMarketplace} />
        </Section>
        <Section title="Ближайшие поставки">
          {detail.nearestDeliveries.length > 0 ? (
            detail.nearestDeliveries.map((delivery, index) => (
              <Detail
                key={index}
                label={format(delivery.date, "dd.MM.yyyy", { locale: ru })}
                value={`${delivery.value} шт.`}
              />
            ))
          ) : (
            <Detail label="Нет данных" value="-" />
          )}
        </Section>
        <Section title="Ближайшие поставки в Москву">
          {detail.nearestDeliveriesToMoscow.length > 0 ? (
            detail.nearestDeliveriesToMoscow.map((delivery, index) => (
              <Detail
                key={index}
                label={format(delivery.date, "dd.MM.yyyy", { locale: ru })}
                value={`${delivery.value} шт.`}
              />
            ))
          ) : (
            <Detail label="Нет данных" value="-" />
          )}
        </Section>
      </CardContent>
    </Card>
  );
};
